import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=3c179abe&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=3c179abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c179abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c179abe')) {
      api.createRecord('3c179abe', component.options)
    } else {
      api.reload('3c179abe', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=3c179abe&scoped=true&", function () {
      api.rerender('3c179abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XuV7r8y9zRrG/JS/comp/PopupBox.vue"
export default component.exports